module.exports = __webpack_public_path__ + "static/react-abbf470862737b0d835c677c2c3529e8.png";